module.exports = __webpack_public_path__ + "static/img/9.5d8f58f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/sp/9.png
// module id = vp0P
// module chunks = 0